const BASE_URL = "/changes-logs";

export default [
  {
    path: `${BASE_URL}`,
    name: "ChangesLogs",
    component: () => import("@/modules/changes_log/view/ChangesLogs.vue"),
  },
  {
    path: `${BASE_URL}/cancelled-purchase-receipts`,
    name: "CancelledPurchaseReceipts",
    component: () => import("@/modules/changes_log/view/CancelledPurchaseReceipts.vue"),
  },
  {
    path: `${BASE_URL}/approval-document-withdrawal`,
    name: "ApprovalDocumentWithdrawal",
    component: () => import("@/modules/changes_log/view/ApprovalDocumentWithdrawal.vue"),
  },
];
